import TRC_CONTENT from '@/constants/trcContentType';
import TRCFilterModalWrapper from '@/TRC/components/filterModalWrapper';
import TRCSortModal from '@/TRC/components/sortModal';
import { useFilters } from '@/v2/hooks/useFilters';

const MobileTopSectionWithFilter = ({ contents, setContents, category, contentType, containsPdf = false }) => {
	const filters = useFilters(TRC_CONTENT.TRC);

	return (
		<div className={'d-flex justify-content-between align-items-center d-lg-none pt-2'}>
			<h4 className="d-lg-none w-100 px-2 text-white text-left fw-bold m-0" style={{ fontFamily: 'Good Times' }}>
				{category}
			</h4>
			<div className="d-flex justify-content-between align-items-center gap-0">
				<TRCSortModal filters={filters} containsPdf={containsPdf} />
				<TRCFilterModalWrapper
					contents={contents}
					setContents={setContents}
					contentType={contentType}
					filters={filters}
					category={category}
				/>
			</div>
		</div>
	);
};

export default MobileTopSectionWithFilter;
